import React, { useState, useEffect } from "react";
import { HTTP } from "../../api/resources";

const PostActions = ({post, updatePost, currentPage, user, fromProjects = false}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSubmit = (action, post, event) => {
    event.preventDefault()
    
    setIsOpen(false)
    HTTP.patch(`/users/${post.user_id}/posts/${post.id}/approve`, {
      approved: action,
      project_id: post.project_id
    }).then(response => {
      if (action == 'approve') {
        Alert.show("notice", "Post approved!");
        setTimeout(() => setIsOpen(false), 2000)
      } else {
        Alert.show("notice", "Post unapproved");
        setTimeout(() => setIsOpen(false), 2000)
      }

      updatePost(post, response.data);
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
    })
  }

  const handleDelete = (post) => {
    setIsOpen(false)
    let id = 0
    if (post.user_id) {
      HTTP.delete(`/users/${post.user_id}/posts/${post.id}.json`)
      .then(response => {
        if (currentPage === 'post_show') {
          window.location.replace(`/users/${post.user_id}/posts/`);
        } else {
          window.location.reload();
        }
      }).catch(e => {
        Alert.show("error", "Could not delete post. Try again or refresh.");
      })
    } else {
      HTTP.delete(`/projects/${post.project_id}/posts/${post.id}.json`)
      .then(response => {
        if (currentPage === 'post_show') {
          window.location.replace(`/projects/${post.project_id}/posts/`);
        } else {
          window.location.reload();
        }
      }).catch(e => {
        Alert.show("error", "Could not delete post. Try again or refresh.");
      })
    }
  }


  const manager = window.clarity.cu.type == 'manager' || window.clarity.cu.type == 'assistant_manager';
  const usingApprovals = window.clarity.ct.ua;

  const showApprovalActions = (post) => {
    if (post.user.user_type == 'manager' || post.user.user_type == 'assistant_manager') {
      return false;
    }

    if (usingApprovals && manager) {
      return true;
    }

    if (usingApprovals && post.user.user_type == 'beneficiary' && user.user_type == 'sponsorship_manager' && user.approve_beneficiary_post) {
      return true
    }

    if (usingApprovals && post.user.user_type == 'donor' && user.user_type == 'sponsorship_manager' && user.approve_donor_post) {
      return true
    }

    return false;
  }

  const showActions = (post) => {
    if (post.user && post.user.user_type == 'manager' && user.user_type !== 'manager') {
      return false 
    }

    if (manager) {
      return true;
    }

    if ((user.user_type == "project_manager" || user.user_type == "project_coordinator") && post.project && post.project.name) {
      return true;
    }

    if (user.user_type == 'sponsorship_manager' && post.user.user_type == 'beneficiary') {
      return true
    }

    if (post.user_id == user.id) {
      return true
    }

    return false;
  }

  const editable = (post) => {
    if (post.user && post.user.user_type == 'manager' && user.user_type !== 'manager') {
      return false 
    }

    if (manager) {
      return true;
    }

    if ((user.user_type == "project_manager" || user.user_type == "project_coordinator") && post.project && post.project.name) {
      return true;
    }

    if (user.user_type == 'sponsorship_manager' && post.user.user_type == 'beneficiary') {
      return true
    }

    return usingApprovals && post.approved_at ? false : true;
  }

  const handlePrint = () => {
    setIsOpen(false) 
    if (post.project && post.project.name) {
      window.open(`/printer/${post.project_id}/${post.id}/project`, '_blank')
      return
    } else {
      window.open(`/printer/${post.user_id}/${post.id}/user`, '_blank')
    }
  }

  const showPin = (post) => {
    if (post.user_id) return false
    if (manager) return true 
    if (user.user_type == 'project_manager' || user.user_type == 'project_coordinator') return true
    return false
  }

  const handlePin = (post, e) => {
    e.preventDefault();

    setIsOpen(false);
    const pinEndpoint = `/post/pin/${post.id}`;
    HTTP.patch(pinEndpoint)
      .then(response => {
        Alert.show('notice', 'Post order updated successfully, reloading page...');
        setTimeout(() => window.location.reload(), 2000)
      })
      .catch(error => {
        Alert.show('error', 'Could not update post order. Try again or refresh.');
      });
  }

  const handleShowToPages = (post, e) => {
    e.preventDefault();

    setIsOpen(false);
    const pinEndpoint = `/post/show_to_pages/${post.id}`;
    HTTP.patch(pinEndpoint)
      .then(response => {
        Alert.show('notice', 'Post accessibility for pages updated, reloading page...');
        setTimeout(() => window.location.reload(), 2000)
      })
      .catch(error => {
        Alert.show('error', 'Could not update post. Try again or refresh.');
      });
  }

  return (
    <div className="card-actions post-action-icon-button">
        <div className="dropleft d-block">
          <button className="btn btn-icon cu-for-action-text" type="button" onClick={toggleDropdown} style={{ background: 'none' }} >
            <i className="far fa-ellipsis-v"></i>
          </button>
          {isOpen && 
            <div className="dropdown-menu" style={{ display: 'block' }}>
              {showApprovalActions(post) && 
                <>
                  {post.approved_at && <a href="#" className="dropdown-item text-danger" onClick={(e) => handleSubmit('block', post, e)}>Unapprove</a>}
                  {!post.approved_at && <a href="#" className="dropdown-item text-success" onClick={(e) => handleSubmit('approve', post, e)}>Approve</a>}
                </>
              }

              {showPin(post) &&
                <a href="#" className="dropdown-item" onClick={(e) => handlePin(post, e)}>{post.pinned ? 'Unpin' : 'Pin'}</a>
              }

              {showPin(post) &&
                <a href="#" className="dropdown-item" onClick={(e) => handleShowToPages(post, e)}>{post.show_in_pages ? 'Hide In Pages' : 'Show In Pages'}</a>
              }

              {editable(post) && (
                <a className="dropdown-item" href={post.edit_url} onClick={() => setIsOpen(false)}>Edit post</a>
              )}

              {post.user_id &&
                <a href={`${post.url}`} className="dropdown-item">Comment</a>
              }

              <a href="#" className="dropdown-item" onClick={handlePrint}>Print</a>

              {showActions(post) &&
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={() => {
                    setIsOpen(false)
                    if (window.confirm('Are you sure you wish to delete this post?')) 
                    handleDelete(post) 
                  } }
                >
                  Delete
                </a>
              }
            </div>
          }
      </div>
    </div>
  );
}

export default PostActions;
